import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=664d36b8&scoped=true"
import script from "./Talent.vue?vue&type=script&setup=true&lang=ts"
export * from "./Talent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Talent.vue?vue&type=style&index=0&id=664d36b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d36b8",
  null
  
)

export default component.exports